import { Plane, Vector3 } from 'three';
import { Nodes } from '../types/model.types';
import { RenderComponentStrategy } from './render-component.strategy';

export class UprightFrame extends RenderComponentStrategy<{ height: number }> {
	componentKey = 'Support_20';

	public override render(nodes: Nodes) {
		const geometry = this.getGeometry(nodes);
		const {
			color,
			scale,
			position,
			rotation,
			options: { height },
		} = this.options;

		const clippingPlane = new Plane(
			new Vector3(0, -1, 0),
			this.getClippingPlaneConstant(height),
		);

		return (
			<mesh geometry={geometry} rotation={rotation} position={position} scale={scale}>
				<meshStandardMaterial color={color} clippingPlanes={[clippingPlane]} clipShadows />
			</mesh>
		);
	}

	private getClippingPlaneConstant(height: number) {
		const results: Record<number, number> = {
			2: 0,
			2.5: 0.3,
			3: 0.625,
			3.5: 0.925,
			4: 1.25,
		};

		return results[height];
	}
}
